import Vue from "vue";
import Vuex from "vuex";
import { auth } from "./auth.module";
import casefiles from "./modules/casefiles";
import dashboard from "./modules/dashboard";
import claimsV2 from "./modules/claimsV2";
import { fileModule } from "./file.module";
// import createPersistedState from "vuex-persistedstate";
import vuexLogger from "@/plugins/vuexLogger";
import settings from "./settings.module"; // <-- add this
import referenceData from "./referenceData.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbars: [],
    snackbarQueue: [],
    maxVisibleSnackbars: 3,
    caseState: fileModule.state,
  },

  mutations: {
    SET_SNACKBAR(state, snackbar) {
      const newSnackbar = {
        ...snackbar,
        id: Date.now(),
        showing: true,
      };

      if (
        state.snackbars.filter((s) => s.showing).length >=
        state.maxVisibleSnackbars
      ) {
        state.snackbarQueue.push(newSnackbar);
      } else {
        state.snackbars.push(newSnackbar);
      }
    },
    REMOVE_SNACKBAR(state, snackbarId) {
      const index = state.snackbars.findIndex((s) => s.id === snackbarId);
      if (index !== -1) {
        state.snackbars.splice(index, 1);

        if (state.snackbarQueue.length > 0) {
          state.snackbars.push(state.snackbarQueue.shift());
        }
      }
    },
    CLEANUP_OLD_SNACKBARS(state) {
      state.snackbars = state.snackbars.filter((s) => s.showing);
    },
  },
  actions: {
    setSnackbar({ commit }, payload) {
      commit("SET_SNACKBAR", payload);
      // Log only error snackbars
      // if (payload.color === "error" || payload.type === "error") {
      //   logEvent({
      //     action: "snackbar_error",
      //     feature: "ui",
      //     status: "failure",
      //     meta: { message: payload.text },
      //     user: rootState.auth?.user,
      //   });
      // }
    },
  },

  modules: {
    auth,
    fileModule,
    casefiles,
    dashboard,
    claimsV2,
    settings, // <-- add this
    referenceData,
  },

  getters: {
    getCaseState: function (state) {
      return state.caseState;
    },
    // Used in Home.vue, Archive.vue, reportsV1.vue, reports-master.vue
    getPaginatedPage: (state) => state.casefiles.paginatedPermitted.page,
    getPaginatedPageSize: (state) =>
      state.casefiles.paginatedPermitted.pageSize,
    getPaginatedLoading: (state) =>
      state.casefiles.paginatedPermitted.isLoading,
    getPaginatedTotal: (state) => state.casefiles.paginatedPermitted.total,
    getPaginatedAll: (state) => state.casefiles.paginatedAll.data,
    getPaginatedTotalAll: (state) => state.casefiles.paginatedAll.total,
    getPaginatedAllLoading: (state) => state.casefiles.paginatedAll.isLoading,
    getPaginatedPermitted: (state) => state.casefiles.paginatedPermitted.data,
    getPaginatedTotalPermitted: (state) =>
      state.casefiles.paginatedPermitted.total,
    getPaginatedPermittedLoading: (state) =>
      state.casefiles.paginatedPermitted.isLoading,

    // NEW: Filtered permitted casefiles (Active: not CANC/CLO)
    getPaginatedPermittedActive: (state) =>
      state.casefiles.paginatedPermittedActive.data,
    getPaginatedTotalPermittedActive: (state) =>
      state.casefiles.paginatedPermittedActive.total,
    getPaginatedPermittedActiveLoading: (state) =>
      state.casefiles.paginatedPermittedActive.isLoading,
    // NEW: Filtered permitted casefiles (Archive: CANC/CLO only)
    getPaginatedPermittedArchive: (state) =>
      state.casefiles.paginatedPermittedArchive.data,
    getPaginatedTotalPermittedArchive: (state) =>
      state.casefiles.paginatedPermittedArchive.total,
    getPaginatedPermittedArchiveLoading: (state) =>
      state.casefiles.paginatedPermittedArchive.isLoading,
  },
  plugins: [vuexLogger],
});
